<template>
    <div class="c-tag" :class="tagStyle">
        <slot></slot>
    </div>
</template>

<script>

/**
 * @file 标签
 * @author
 */
export default {
    props: {
        // 标签尺寸
        size: {
            'type': String,
            'default': 'normal'
        },
        // 标签主题色
        color: {
            'type': String,
            'default': ''
        },
        // 标签类型
        type: {
            'type': String,
            'default': 'gray'
        }
    },
    data() {
        return {
        };
    },
    computed: {
        tagStyle() {
            let tagStyle = '';
            const {type} = this;
            if (type) {
                tagStyle = `c-tag-${type}`;
            }
            return tagStyle;
        }
    }
};
</script>
<style scoped lang="less">
.c-tag {
    font-family: PingFangSC-Regular;
    display: inline-block;
    font-size: 12px;
    line-height: 12px;
    padding: 2px 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    display: inline-block;
    margin-left: 5px;
    font-weight: normal!important
}
.c-tag-gray {
    color: #4F535E;
    background-color: #f1f2f3;
}
.c-tag-red {
    color: #FE4455;
    background: #fff0f2;
}
.c-tag-blue {
    color: #356FFF;
    background-color: #EDF2FF;
}
.c-tag-cyan {
    color: #058FC0;
    background-color: #DEF2FC;
}
.c-tag-green {
    color: #06C7CC;
    background-color: #ebfbfb 
}
</style>